export default {
  visible: true,
  type: null,
  message: null,
  canclose: true,
};
